import React from 'react';
import { connect } from 'react-redux';
import FeedbackDetail from '../../v2/FeedbackDetail';
import UserTable from '../../UserTable';
import Modal from '../../Modal';
import Loading from '../../Loading';
import FeedbackInbox from '../../v2/FeedbackInbox';
import { connectWebsocket, setSelectedFeedback } from '../../redux/FeedbackRedux';
import FeedbackDetailBar from '../../v2/FeedbackDetailBar';
import FilterBar from '../../v2/FilterBar';

class FeedbackerDetail extends React.Component {
    componentDidMount() {
        this.props.dispatch(connectWebsocket());
        this.props.dispatch(setSelectedFeedback(this.props.state.selected_feedback));
    }

    render() {
        return (
            <div className="">
                <Loading location={'page'} />


                {this.props.state.feedback_detail &&
                    <FeedbackDetailBar />
                    // :
                    // <FilterBar />
                }
                {/* {this.props.state.user_table != null && this.props.state.feedback_detail === null &&
                    <UserTable />
                } */}

                {this.props.state.feedback_detail ?
                    <FeedbackDetail />
                    :
                    <FeedbackInbox />
                }

                <Modal modal={this.props.state.modal} />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return { state: state }
}

export default connect(mapStateToProps)(FeedbackerDetail);
